import graphql from 'babel-plugin-relay/macro'
import {commitMutation} from 'react-relay'




const mutation = graphql`
  mutation UploadUserImageMutation($file: File!) {
    uploadUserImage(file: $file) {
      error {
        message
      }
      user {
        id
        picture
      }
    }
  }
`

const UploadUserImageMutation = (
  atmosphere,
  variables,
  {onCompleted, onError},
  uploadables
) => {
  return commitMutation(atmosphere, {
    mutation,
    variables: variables ,
    uploadables,
    onCompleted,
    onError
  })
}

export default UploadUserImageMutation
